const LAST_KITCHEN_COMPOSITION_ID_KEY = "upme.lastKitchenCompositionId"

const toKitchenCompositionId = (source) => {
    if (source == null || source === "") {
        return null
    }
    if (typeof source !== "object") {
        return source
    }
    const value = source.compositionId ?? source.composition?.id ?? source.originalComposition?.id
    if (value == null || value === "" || typeof value === "object") {
        return null
    }
    return value
}

export const rememberKitchenCompositionId = (compositionId) => {
    const id = toKitchenCompositionId(compositionId)
    if (id == null) {
        return
    }
    try {
        sessionStorage.setItem(LAST_KITCHEN_COMPOSITION_ID_KEY, String(id))
    } catch {
        // ignore quota / private mode
    }
}

export const readRememberedKitchenCompositionId = () => {
    try {
        const value = sessionStorage.getItem(LAST_KITCHEN_COMPOSITION_ID_KEY)
        return value == null || value === "" ? null : value
    } catch {
        return null
    }
}

export const readKitchenCompositionIdFromLocation = () => {
    try {
        const fromSearch = new URLSearchParams(window.location.search).get("compositionId")
        if (fromSearch) {
            return fromSearch
        }
        const hash = window.location.hash || ""
        const queryIndex = hash.indexOf("?")
        if (queryIndex >= 0) {
            return new URLSearchParams(hash.slice(queryIndex + 1)).get("compositionId")
        }
    } catch {
        // ignore invalid URL
    }
    return null
}

export const pickKitchenCompositionId = (...sources) => {
    for (const source of sources) {
        const id = toKitchenCompositionId(source)
        if (id != null) {
            return id
        }
    }
    return toKitchenCompositionId(readKitchenCompositionIdFromLocation())
        ?? readRememberedKitchenCompositionId()
}

export const withCompositionIdQuery = (path, compositionId, compositionName) => {
    if (path == null || compositionId == null || compositionId === "") {
        return path
    }
    const separator = String(path).includes("?") ? "&" : "?"
    const params = new URLSearchParams()
    params.set("compositionId", String(compositionId))
    if (compositionName != null && compositionName !== "") {
        params.set("compositionName", String(compositionName))
    }
    return `${path}${separator}${params.toString()}`
}
